export const enum DateFormat {
  M_DD_YY = 'M/DD/YY',
  MM_DD_YYYY = 'MM/DD/YYYY',
  YYYY_MM_DD = 'YYYY_MM_DD',
}
